import AJAX from 'utils/ajax'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

class InfiniteHitsWidget {
  constructor(opts) {
    return instantsearch.connectors.connectInfiniteHits(this.render(opts))
  }

  render(opts) {
    let cachedIds = ""
    let showingMore = false

    return function(renderOptions, isFirstRender) {
      const buttonId = "load-more-button"
      const { hits, results, widgetParams, isLastPage, showMore } = renderOptions
      const container = document.querySelector(widgetParams.container)

      // Map ids from ALL hits present in page to compare to cachedIds
      const ids = hits.map((it) => { return parseInt(it.id) }).toString()

      if (isFirstRender) {
        const button = document.createElement('button')
        button.innerHTML = widgetParams.templates.showMoreText
        button.id = buttonId
        button.classList = `${widgetParams.cssClasses.loadMore} hidden`

        button.addEventListener('click', function() {
          this.innerHTML = opts.loadingDisableWith
          this.disabled = true
          showingMore = true
          showMore()
        })

        container.appendChild(button)

        return
      }

      // Only call the server if the list of ids is different
      if (ids !== cachedIds) {
        // Map only the NEW PAGE hits to fetch them from the server
        const items = results.hits.map(item => item.id)
        const coursesContainer = document.getElementById(opts.itemsContainerId)
        const button = document.getElementById(buttonId)

        coursesContainer.dataset.currentItems = ids
        if (!showingMore) {
          // This is for when the list gets refreshed clicking a filter checkbox
          coursesContainer.innerHTML = ""
          hideElement(button)
          showElement(opts.loadingIndicator)
        }

        AJAX.get(
          `${opts.itemsEndpointUrl}?courses=${items}`
        ).then((response) => {
          return response.text()
        }).then((html) => {
          hideElement(opts.loadingIndicator)
          if (showingMore) {
            button.innerHTML = widgetParams.templates.showMoreText
            button.disabled = false
            coursesContainer.insertAdjacentHTML('beforeend', html)
            showingMore = false
          } else {
            coursesContainer.innerHTML = html
          }

          if (opts.afterLoadCallback !== undefined) {
            opts.afterLoadCallback()
          }

          // If there are no more pages we hide the load more button
          if (isLastPage) {
            hideElement(button)
          } else {
            showElement(button)
          }
        })
      }

      cachedIds = ids
    }
  }
}

export default InfiniteHitsWidget
